import { render, staticRenderFns } from "./ModalLogin.vue?vue&type=template&id=80fbef68"
import script from "./ModalLogin.vue?vue&type=script&lang=js"
export * from "./ModalLogin.vue?vue&type=script&lang=js"
import style0 from "./ModalLogin.vue?vue&type=style&index=0&id=80fbef68&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports